

export const SORT_ICON_SIZE_DEFAULT = 7;